import React, { useEffect, useState } from "react";
import { ShieldCheck, Phone } from "lucide-react";
import { api } from "@/lib/api";

export default function Schemes() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/schemes").then((r) => setItems(r.data)); }, []);
  return (
    <div data-testid="schemes-page">
      <section className="hero-bg py-12">
        <div className="container-x">
          <span className="font-cursive text-2xl text-brand-purple">Government Health Schemes</span>
          <h1 className="text-4xl sm:text-5xl font-bold">Care is your right.</h1>
          <p className="text-slate-600 mt-3 max-w-2xl">We process cashless claims under all major government health schemes.</p>
        </div>
      </section>
      <section className="container-x py-10 grid md:grid-cols-2 gap-6">
        {items.map((s) => (
          <div key={s.id} className="card-clean p-6" data-testid={`scheme-${s.id}`}>
            <div className="flex items-center gap-3 mb-3"><div className="h-10 w-10 rounded-lg bg-brand-green/15 text-brand-green grid place-items-center"><ShieldCheck className="h-5 w-5" /></div><h3 className="font-bold text-xl">{s.name}</h3></div>
            <div className="text-sm space-y-2">
              <p><span className="font-semibold text-slate-900">Eligibility:</span> <span className="text-slate-600">{s.eligibility}</span></p>
              <p><span className="font-semibold text-slate-900">Benefits:</span> <span className="text-slate-600">{s.benefits}</span></p>
              <div>
                <span className="font-semibold text-slate-900">Documents Required:</span>
                <ul className="list-disc pl-5 text-slate-600 mt-1">{s.documents?.map((d, i) => <li key={i}>{d}</li>)}</ul>
              </div>
              <p className="flex items-center gap-2 pt-2 text-brand-purple font-semibold"><Phone className="h-4 w-4" /> {s.contact}</p>
            </div>
          </div>
        ))}
      </section>
    </div>
  );
}
